export default "__VITE_ASSET__Cm_DZq09__"